import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  SearchBar,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox,
  Dialog,
  Button,
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from '../lib/formatter.ts';
import Util from 'lib/util.js';
import Http from 'services/http2';
import User from 'services/user2';
import EnumService from 'services/enum2';
import TopNav from 'components/topNav.js';
import CompanyService from 'services/company2';
import ClearIcon from '@material-ui/icons/Clear';
import * as MobileActions from 'actions/index.ts';
import CommonFns from 'functions/common.ts';
import dayjs from 'dayjs';

import Drawer from '@material-ui/core/Drawer';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import TodayIcon from '@material-ui/icons/Today';
import { withStyles } from '@material-ui/core/styles';

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Fplan%2Ftpp%2Fboard&response_type=code&scope=snsapi_base&state=123#wechat_redirect
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fsale%2Fplan%2Ftpp%2Fboard&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

const styles = theme => ({
  inputAdornment: {
    margin: 0,
    width: '200px',
  },
});

const Config = {
  customerPlanTppBoard: {
    title: '订单直运看板',
    deliveryQtyName: '送货数量',
    apiPath: '/b2bCustomerDirectDeliveryBoard/list',
    enumMainKey: 'B02_Direct_Status',
    companyNameKey: 'innerCustomerName',
    companyCodeKey: 'innerCustomerCode',
    searchBarPlaceholder: '客户名称/编码、订单编号、商品名称/编码/规格',
    tabs: ['全部', '待答交', '待送货'],
    status: [undefined, 5, 1],
  },
  purchasePlanTppBoard: {
    title: '订单直运看板',
    deliveryQtyName: '到货数量',
    apiPath: '/b2bDirectDeliveryBoard/list',
    enumMainKey: 'B02_Direct_Status',
    companyNameKey: 'innerVendorName',
    companyCodeKey: 'innerVendorCode',
    searchBarPlaceholder: '供应商名称/编码、订单编号、商品名称/编码/规格',
    tabs: ['全部', '未发货', '差异待确认'],
    status: [0, 1, 6],
  },
};

class PlanTppBoard extends Component {
  constructor(props) {
    super(props);
    this.reset = false;
    this.companyCode = '';
    this.pageNum = 1;
    this.searchKey = '';
    this.total = 0;
    this.handleClear = this.handleClear.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.successFn = this.successFn.bind(this);
    this.errorFn = this.errorFn.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.dateChange = this.dateChange.bind(this);
    this.config = Config[props.type];
    this.resolveLoading = () => { }; //引用InfiniteLoader中resolveLoading方法，用于重置列表加载状态
    this.count = [];
    this.currentTab = 0; //当前页签
    this.state = {
      inited: false,
      error: null,
      dataError: null,
      list: [],
      showLoading: true,
      showToast: false,
      showError: false,
      isShowSearch: false,
      status: this.config.status[this.currentTab],
      returnBottom: false,
      replyBottom: false,
      isBackTxtError: false,
      backHelperText: '',
      sendBackTxt: '',
      commitTime: '',
      commitQty: '',
      showIOS2: false,
      unitNum: {},
      style2: {
        title: '',
        buttons: [
          {
            type: 'default',
            label: '取消',
            onClick: this.hideDialog.bind(this),
          },
          {
            type: 'primary',
            label: '确认',
            onClick: this.handleOrder.bind(this),
          },
        ],
      },
    };
    this.isPurchase = props.type === 'purchasePlanTppBoard';
    this.type = '';
    this.currItem = null;
    this.dialogMsg = '';
    this.container = React.createRef();
  }

  init() {
    User.init().then(response => {
      if (response.success) {
        this.setState({ inited: true });
        this.companyCode = User.getCompanyCode();
        this.getList();
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() { }

  hideDialog() {
    this.setState({
      showIOS2: false,
    });
  }

  getList(cb = () => { }) {
    let enumMainKey = this.config.enumMainKey;
    let postbody = {
      apiPath: this.config.apiPath,
      ascOrDesc: 'desc',
      companyCode: this.companyCode,
      orderProperty: 'createTime',
      status: this.state.status,
      pageNum: this.pageNum,
      pageSize: 10,
      searchKey: this.searchKey,
    };
    let arrPromise = [
      Http.post('/api/cloudCenter', postbody),
      EnumService.getList(enumMainKey),
    ];
    this.setState({ dataError: null });
    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      this.reset = false;
      this.setState({ showLoading: false });
      if (response.success) {
        this.setState(
          { list: this.state.list.concat(response.data.list) },
          () => cb()
        );
        this.pageNum += 1;
        this.total = response.data.total;
        this.state.list.forEach((item, index) => {
          if ([5, 7].includes(item.status) && Util.isEmpty(item.commitQty)) {
            item.commitQty = item.deliveryQty;
          }
          if ([5, 7].includes(item.status) && Util.isEmpty(item.commitTime)) {
            item.commitTime = item.arriveTime;
          }
          if (item.statusName === undefined) {
            EnumService.getValue(enumMainKey, item.status).then(value => {
              item.statusName = value;
              if (index === this.state.list.length - 1) {
                this.forceUpdate();
              }
            });
          }
          //小数位获取
          let companyCode =
            this.props.type === 'customerPlanTppBoard'
              ? item.customerCode
              : this.companyCode;
          CompanyService.getDecimalPlaceByCodes(companyCode).then(rs => {
            let obj = {};
            for (let code in rs) {
              obj[code] = rs[code];
            }
            this.setState({ unitNum: obj });
          });
        });
      } else {
        this.setState({
          dataError: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  handleCompanyChange(companyCode) {
    this.companyCode = companyCode;
    this.setState({ showLoading: true });
    this.handleReset();
  }

  handleChange(text, e) {
    e.preventDefault();
    this.searchKey = text;
    this.handleReset();
  }

  handleClear() {
    this.searchKey = '';
    this.handleReset();
  }

  handleTab(index) {
    this.currentTab = index;
    this.setState(
      {
        status: this.config.status[index],
      },
      () => {
        this.handleReset();
      }
    );
  }

  handleReset() {
    this.reset = true;
    this.setState({
      list: [],
    });
    this.pageNum = 1;
    this.setState({ showLoading: true });
    this.getList();
    this.resolveLoading();
  }

  toggleSearch() {
    let isShowsearch = !this.state.isShowSearch;
    this.setState({ isShowSearch: isShowsearch });
  }

  search(text) {
    this.searchKey = text;
    this.setState({ showLoading: true });
    this.getList();
  }

  // 显示弹窗
  toggleDrawer = (side, open, item, index) => () => {
    this.setState({
      [side]: open,
    });
    this.currItem = item;
    if (open && !this.isPurchase) {
      let commitTime = dayjs(this.currItem.commitTime).format('YYYY-MM-DD');
      this.setState({
        commitTime: commitTime,
        commitQty: this.currItem.commitQty,
      });
    }
  };

  handle(type, item) {
    switch (type) {
      case 'publish':
        this.dialogMsg = '确认发布此看板？';
        break;
      case 'ok':
        this.dialogMsg = '是否确认此操作？';
        break;
      default:
    }
    this.type = type;
    this.currItem = item;
    this.setState({ showIOS2: true });
  }

  handleOrder() {
    this.hideDialog();
    this.setState({ showLoading: true });
    switch (this.type) {
      case 'publish':
        this.public(this.currItem);
        break;
      case 'ok':
        this.replyOK(this.currItem);
        break;
      default:
    }
  }

  //发布
  public(item) {
    let postbody = {
      companyCode: this.companyCode,
      lineUniqueCode: item.lineUniqueCode,
      apiPath: '/b2bDirectDeliveryBoard/publish',
    };
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      if (response.success) {
        this.successFn();
      } else {
        this.errorFn(response.errorMsg);
      }
    });
  }

  //确认差异
  replyOK(item) {
    let postbody = {
      companyCode: this.companyCode,
      lineUniqueCode: item.lineUniqueCode,
      apiPath: '/b2bDirectDeliveryBoard/confirm',
    };
    Http.post('/api/cloudCenter?btnId=002', postbody).then(response => {
      if (response.success) {
        this.successFn();
      } else {
        this.errorFn(response.errorMsg);
      }
    });
  }

  //退回
  replyReturn = () => {
    if (Util.isEmpty(this.state.sendBackTxt)) {
      this.setState({
        isBackTxtError: true,
        backHelperText: '退回原因不能为空！',
      });
      return;
    }
    let postbody = {
      companyCode: this.companyCode,
      lineUniqueCode: this.currItem.lineUniqueCode,
      backReason: this.state.sendBackTxt,
      apiPath: '/b2bDirectDeliveryBoard/back',
    };
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter?btnId=003', postbody).then(response => {
      if (response.success) {
        this.successFn();
      } else {
        this.errorFn(response.errorMsg);
      }
      this.setState({ returnBottom: false, showLoading: false });
    });
  };

  //回复
  replyDelivery = () => {
    if (!this.currItem) {
      return;
    }
    if (Util.isEmpty(this.state.commitQty)) {
      this.errorFn('答交数量不能为空');
      return;
    }
    if (Util.isEmpty(this.state.commitTime)) {
      this.errorFn('答交时间不能为空');
      return;
    }
    if (this.state.commitQty > this.currItem.deliveryQty) {
      this.errorFn('答交数量不能大于送货数量');
      return;
    }
    let postbody = {
      companyCode: this.companyCode,
      lineCodes: this.currItem.lineUniqueCode,
      commitQty: this.state.commitQty,
      commitTime: Date.parse(this.state.commitTime),
      apiPath: '/b2bCustomerDirectDeliveryBoard/commitDelivery',
    };
    Http.post('/api/cloudCenter?btnId=004', postbody).then(response => {
      if (response.success) {
        this.successFn();
      } else {
        this.errorFn(response.errorMsg);
      }
      this.setState({ replyBottom: false, showLoading: false });
    });
  };

  successFn() {
    this.setState({ showLoading: false, showToast: true });
    this.toastTimer = setTimeout(() => {
      this.setState({ showToast: false });
    }, 2000);
    this.handleReset();
  }

  errorFn(errorMsg) {
    this.errorMsg = errorMsg;
    this.setState({ showLoading: false });
    this.setState({ showError: true });
    this.errorTimer = setTimeout(() => {
      this.setState({ showError: false });
    }, 2000);
  }

  // 修改信息
  handleTextChange = name => event => {
    if (this.isPurchase) {
      if (Util.isEmpty(event.target.value)) {
        this.setState({
          isBackTxtError: true,
          sendBackTxt: event.target.value,
          backHelperText: '退回原因不能为空！',
        });
      } else {
        this.setState({
          isBackTxtError: false,
          sendBackTxt: event.target.value,
          backHelperText: '',
        });
      }
    } else {
      let val = Util.qtyChange(event.target.value);
      this.setState({
        [name]: val,
      });
    }
  };

  // IOS键盘收起时留白问题
  onBlur = () => {
    this.container.current.scrollIntoView({ behavior: 'smooth' });
  };

  //日期改变
  dateChange(i, e) {
    let value = e.target.value;
    this.setState({ commitTime: value });
  }

  render() {
    const { classes } = this.props;
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    const unitNum = this.state.unitNum;
    return (
      <Page
        transition={false}
        ptr={false}
        onLoadMore={(resolveLoading, finish) => {
          this.resolveLoading = resolveLoading;
          if (this.state.list.length >= this.total) {
            finish();
          } else {
            this.getList(resolveLoading);
          }
        }}
        className="v2"
      >
        <TopNav
          inited={this.state.inited}
          onSubmit={this.handleChange}
          onCancel={this.handleClear}
          onClear={this.handleClear}
          defaultValue={this.searchKey}
          placeholder={this.config.searchBarPlaceholder}
        />
        <Panel>
          {this.state.isShowSearch && (
            <SearchBar
              onSubmit={this.handleChange}
              onCancel={this.handleClear}
              onClear={this.handleClear}
              defaultValue={this.searchKey}
              placeholder={this.config.searchBarPlaceholder}
              lang={{
                cancel: '取消',
              }}
            />
          )}

          {this.state.dataError !== null ? (
            <Msg {...this.state.dataError} />
          ) : (
            <span>
              <div className="m-tab-container">
                <ul className="m-flex-box">
                  {this.config.tabs.map((item, index) => (
                    <li
                      key={index}
                      onClick={this.handleTab.bind(this, index)}
                      className={
                        this.currentTab === index
                          ? 'm-flex-item curr'
                          : 'm-flex-item'
                      }
                    >
                      <span className="name">{item}</span>
                    </li>
                  ))}
                </ul>

                {this.searchKey && (
                  <div className="searchKeyBox">
                    查询信息：
                    <div onClick={this.handleClear}>
                      <span className="singleOmission">{this.searchKey}</span>
                      <ClearIcon
                        className="verticalMiddle"
                        color="primary"
                        fontSize="inherit"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="list-total">{this.total}</div>
              <div className="m-details-item">
                <div className="details-item-content">
                  {this.state.list.map((item, index) => (
                    <Link to="#" key={index} className="content-line line-list-item">
                      <div className="line-list-item-title">
                        <span>{item.poErpNo}（{item.poLineNoShow}）</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('tpp', item.status, this.isPurchase)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {this.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!this.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>产品编码</label>
                          <div>{item.productCode}</div>
                        </li>
                        <li>
                          <label>产品名称</label>
                          <div>{item.productName}</div>
                        </li>
                        <li>
                          <label>产品规格</label>
                          <div>{item.productScale}</div>
                        </li>
                      </ul>
                      <div className="order-detail-more">
                        <ul className="field-list">
                          <li>
                            <span className="field-label">已出货量</span>
                            <div className="field-value">
                              {formatNumber(
                                item.alreadyDeliveryQty,
                                unitNum.Quantity_Decimal_Place
                              )}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">订单待交数量</span>
                            <div className="field-value">
                              {formatNumber(
                                item.canDeliveryQty,
                                unitNum.Quantity_Decimal_Place
                              )}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">到货时间</span>
                            <div className="field-value">{formatDate(item.arriveTime)}</div>
                          </li>
                          <li>
                            <span className="field-label">{this.config.deliveryQtyName}</span>
                            <div className="field-value">
                              {formatNumber(
                                item.deliveryQty,
                                unitNum.Quantity_Decimal_Place
                              )}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">答交交期</span>
                            <div className="field-value">{formatDate(item.commitTime)}</div>
                          </li>
                          <li>
                            <span className="field-label">答交数量</span>
                            <div className="field-value">
                              {formatNumber(
                                item.commitQty,
                                unitNum.Quantity_Decimal_Place
                              )}
                            </div>
                          </li>
                          <li>
                            <span className="field-label">送货说明</span>
                            <div className="field-value">{item.deliveryDesc}</div>
                          </li>
                          {item.status === 7 && item.backReason && (
                            <li>
                              <span className="field-label">{item.statusName}原因</span>
                              <div className="field-value">
                                <span className='red'>{item.backReason}</span>
                              </div>
                            </li>
                          )}
                          {item.status === 8 && item.recallReason && (
                            <li>
                              <span className="field-label">{item.statusName}原因</span>
                              <div className="field-value">
                                <span className='red'>{item.recallReason}</span>
                              </div>
                            </li>
                          )}
                        </ul>
                      </div>
                      <div className="list-bottom clearfix">
                        {this.isPurchase ? (
                          <div className="fr btns">
                            {User.checkAuth('10020403') &&
                              [0, 8].includes(item.status) && (
                                <span
                                  className="u-btn u-btn_primary"
                                  onClick={() => {
                                    this.handle('publish', item);
                                  }}
                                >
                                  发布
                                </span>
                              )}
                            {User.checkAuth('10020403') &&
                              item.status === 6 && (
                                <span
                                  className="u-btn u-btn_primary"
                                  onClick={() => {
                                    this.handle('ok', item);
                                  }}
                                >
                                  确认
                                </span>
                              )}
                            {User.checkAuth('10020403') &&
                              item.status === 6 && (
                                <span
                                  className="u-btn u-btn_line"
                                  onClick={this.toggleDrawer(
                                    'returnBottom',
                                    true,
                                    item,
                                    index
                                  )}
                                >
                                  退回
                                </span>
                              )}
                          </div>
                        ) : (
                          <div className="fr btns">
                            {User.checkAuth('20020401') &&
                              [5, 7].includes(item.status) && (
                                <span
                                  className="u-btn u-btn_primary"
                                  onClick={this.toggleDrawer(
                                    'replyBottom',
                                    true,
                                    item,
                                    index
                                  )}
                                >
                                  回复
                                </span>
                              )}
                          </div>
                        )}
                      </div>
                    </Link>
                  ))}
                  {!this.state.showLoading && this.state.list.length === 0 && (
                    <LoadMore showLine> 暂无数据</LoadMore>
                  )}
                </div></div>
            </span>
          )}
        </Panel>
        {/* 采购退回 */}
        {this.isPurchase && (
          <Drawer
            anchor="bottom"
            open={this.state.returnBottom}
            onClose={this.toggleDrawer('returnBottom', false)}
          >
            <div tabIndex={0} role="button">
              <div className="MuiDrawer-paper">
                <div className="text-field-item" ref={this.container}>
                  <TextField
                    id="outlined-full-width"
                    error={this.state.isBackTxtError}
                    helperText={this.state.backHelperText}
                    label="退回"
                    value={this.state.sendBackTxt}
                    onChange={this.handleTextChange()}
                    margin="normal"
                    onBlur={this.onBlur}
                    rows="3"
                    multiline
                    fullWidth
                    variant="outlined"
                  />
                </div>
                <p className="mt15 m-flex-box">
                  <Button
                    type="default"
                    onClick={this.replyReturn}
                    className="m-flex-item u-btn u-btn_primary"
                  >
                    确定
                  </Button>
                  <Button
                    type="default"
                    onClick={this.toggleDrawer('returnBottom', false)}
                    className="m-flex-item u-btn u-btn_line"
                  >
                    取消
                  </Button>
                </p>
              </div>
            </div>
          </Drawer>
        )}
        {/* 供应商回复 */}
        {!this.isPurchase && this.currItem && (
          <Drawer
            anchor="bottom"
            open={this.state.replyBottom}
            onClose={this.toggleDrawer('replyBottom', false)}
          >
            <div tabIndex={0} role="button">
              <div className="MuiDrawer-paper">
                <div className="text-field-item">
                  {this.currItem[this.config.companyNameKey]}
                </div>
                <div className="text-field-item">
                  采购单号：{this.currItem.poErpNo}（
                  {this.currItem.poLineNoShow}）
                </div>
                <div className="text-field-item">
                  产品编码：{this.currItem.productCode}
                </div>
                <div className="text-field-item">
                  产品名称：{this.currItem.productName}
                </div>
                <div className="text-field-item">
                  产品规格：{this.currItem.productScale}
                </div>
                <div className="text-field-item">
                  到货时间：{formatDate(this.currItem.arriveTime)}
                </div>
                <div className="text-field-item mb10">
                  送货数量：
                  {formatNumber(
                    this.currItem.deliveryQty,
                    unitNum.Quantity_Decimal_Place
                  )}
                </div>
                <div className="text-field-item mb10">
                  答交交期：
                  <TextField
                    label=""
                    variant="outlined"
                    margin="dense"
                    className={classes.inputAdornment}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <TodayIcon />
                        </InputAdornment>
                      ),
                    }}
                    type="date"
                    value={this.state.commitTime}
                    onChange={e => this.dateChange(0, e)}
                  />
                </div>
                <div className="text-field-item mb10">
                  答交数量：
                  <TextField
                    label=""
                    value={this.state.commitQty || ''}
                    onChange={this.handleTextChange('commitQty')}
                    margin="normal"
                    variant="outlined"
                    className={classes.inputAdornment}
                  />
                </div>
                <p className="mt40 m-flex-box">
                  <Button
                    type="default"
                    onClick={this.replyDelivery}
                    className="m-flex-item u-btn u-btn_primary"
                  >
                    确定
                  </Button>
                  <Button
                    type="default"
                    onClick={this.toggleDrawer('replyBottom', false)}
                    className="m-flex-item u-btn u-btn_line"
                  >
                    取消
                  </Button>
                </p>
              </div>
            </div>
          </Drawer>
        )}
        <Dialog
          type="ios"
          title={this.state.style2.title}
          buttons={this.state.style2.buttons}
          show={this.state.showIOS2}
        >
          {this.dialogMsg}
        </Dialog>
        <Toast icon="success-no-circle" show={this.state.showToast}>
          完成
        </Toast>
        <Toast icon="warn" show={this.state.showError}>
          {this.errorMsg}
        </Toast>
        <Toast icon="loading" show={this.state.showLoading}>
          数据加载中...
        </Toast>
      </Page>
    );
  }
}

PlanTppBoard.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PlanTppBoard));
